import { render, staticRenderFns } from "./SftpInstructions.vue?vue&type=template&id=6f9bc462&scoped=true&"
import script from "./SftpInstructions.vue?vue&type=script&lang=js&"
export * from "./SftpInstructions.vue?vue&type=script&lang=js&"
import style0 from "./SftpInstructions.vue?vue&type=style&index=0&id=6f9bc462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9bc462",
  null
  
)

export default component.exports
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QExpansionItem,QInput,QIcon});
